// packages/shared/data/fetchSharingSettings.js

import axios from '../config/axios';

/**
 * Returns:
 * {
 *   settings: {
 *     shared_name, share_profile_picture, sharing, viewing, shared_emails,
 *     allowed_type_ids: number[] | null,
 *     allowed_subtype_ids: number[] | null
 *   },
 *   types: [{ id, key, name, short_label, subtypes: [{id,key,name,short_label}] }]
 * }
 */
const fetchSharingSettings = async (token) => {
  const headers = token ? { Authorization: `Bearer ${token}` } : undefined; // omit if your axios instance already injects auth

  const [settingsRes, typesRes] = await Promise.all([
    axios.get('/me/sharing', { headers }),
    axios.get('/usertypes', { headers }),
  ]);

  const settings = settingsRes.data || {};
  const types = typesRes.data || [];

  // normalize arrays so UI logic is simple
  settings.allowed_type_ids = settings.allowed_type_ids || [];
  settings.allowed_subtype_ids = settings.allowed_subtype_ids || [];

  return { settings, types };
};

export default fetchSharingSettings;
